
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy, Save } from 'lucide-react';
import { toast } from 'sonner';
import InterviewRequestEmailTemplate from '@/components/email/InterviewRequestEmailTemplate';

interface PreviewPanelProps {
  emailConfig: {
    from: string;
    subject: string;
    intervieweeName: string;
    question: string;
    context: string;
    submissionUrl: string;
    baseUrl: string;
  };
  introText: string;
  onSaveTemplate: () => void;
}

export const PreviewPanel: React.FC<PreviewPanelProps> = ({ emailConfig, introText, onSaveTemplate }) => {
  const copyHtmlToClipboard = () => {
    toast.success('HTML kode kopiert til utklippstavlen');
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card className="lg:col-span-2">
        <CardHeader>
          <CardTitle>Forhåndsvisning av e-post</CardTitle>
          <CardDescription>
            Fra: {emailConfig.from} <br />
            Emne: {emailConfig.subject}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="overflow-auto bg-slate-50 p-4 rounded-md">
            <InterviewRequestEmailTemplate
              intervieweeName={emailConfig.intervieweeName}
              question={emailConfig.question}
              context={emailConfig.context}
              submissionUrl={emailConfig.submissionUrl}
              baseUrl={emailConfig.baseUrl}
              introText={introText}
            />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Handlinger</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={copyHtmlToClipboard} 
            className="w-full"
            variant="outline"
          >
            <Copy className="mr-2 h-4 w-4" />
            Kopier HTML
          </Button>
          <Button 
            onClick={onSaveTemplate} 
            className="w-full bg-[#ea384c] hover:bg-[#ea384c]/90 text-white"
          >
            <Save className="mr-2 h-4 w-4" />
            Lagre mal
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
